export enum WidgetMode {
    SEAMLESS = 'SEAMLESS',
    EMBEDDED = 'EMBEDDED',
    HOSTED = 'HOSTED'
}
